/*
 * File: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice\src\Content\PaginationCustom\PaginationCustom.tsx
 * Project: c:\Users\j.mazat\Desktop\Autobuy\AutobuyBackOffice
 * Created Date: Thursday June 22nd 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Tuesday, 8th August 2023 06:35:18
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 */

import { useLocation, useNavigate } from "react-router-dom";
import TablePagination from "@mui/material/TablePagination";
import TablePaginationActions from "Content/PaginationCustom/PaginationAction";
import "Content/PaginationCustom/PaginationCustom.css";
import { ChangeEvent, MouseEvent } from "react";

type PaginationProps = {
    nbItem: number;
    page: number;
    rowsPerPage: number;
    changeRowPerPage: Function;
    changePage: Function;
    rowPerPageOptions?: number[];
}

function PaginationCustom(props: PaginationProps) {
    const navigate = useNavigate();
    const location = useLocation();

    // Avoid a layout jump when reaching the last page with empty rows.
    const emptyRows = props.page > 0 ? Math.max(0, (1 + props.page) * props.rowsPerPage - props.nbItem) : 0;

    const handleChangePage = ( event: MouseEvent<HTMLButtonElement> | null, newPage: number ) => {
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("page", (newPage + 1).toString());
        navigate("?" + searchParams.toString());
        props.changePage(newPage);
    };

    const handleChangeRowsPerPage = ( event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ) => {
        props.changeRowPerPage(parseInt(event.target.value, 10));
        const searchParams = new URLSearchParams(location.search);
        searchParams.set("page", (1).toString());
        props.changePage(0);
        searchParams.set("per_page", (event.target.value).toString());
        navigate("?" + searchParams.toString());
    };

    return (
        <TablePagination
            rowsPerPageOptions={props.rowPerPageOptions ?? [20, 50, 100]}
            count={props.nbItem}
            rowsPerPage={props.rowsPerPage}
            page={props.page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            SelectProps={{
                inputProps: {
                'aria-label': 'rows per page',
                },
                native: true,
            }}
            showFirstButton={true}
            showLastButton={true}
            ActionsComponent={TablePaginationActions}
        />
    )
}

export default PaginationCustom;
